<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations personnelles</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.firstName || originalMetadata?.firstName"
      >
        <span class="card__label" i18n>Prénom</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.firstName !== metadata.firstName,
            }"
            >{{ metadata.firstName }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.firstName &&
              originalMetadata.firstName !== metadata.firstName
            "
            >{{ originalMetadata.firstName }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.lastName || originalMetadata?.lastName"
      >
        <span class="card__label" i18n>Nom</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.lastName !== metadata.lastName,
            }"
            >{{ metadata.lastName }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.lastName &&
              originalMetadata.lastName !== metadata.lastName
            "
            >{{ originalMetadata.lastName }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.dob || originalMetadata?.dob">
        <span class="card__label" i18n>Date de naissance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && originalMetadata.dob !== metadata.dob,
            }"
            >{{ metadata.dob | date: DATE_FORMAT }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.dob && originalMetadata.dob !== metadata.dob
            "
            >{{ originalMetadata.dob | date: DATE_FORMAT }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.avsNumber">
        <span class="card__label" i18n>Numéro AVS</span>
        <span class="card__value">{{ metadata.avsNumber }}</span>
      </div>
      <div class="card__row" *ngIf="metadata?.gender">
        <span class="card__label" i18n>Genre</span>
        <span class="card__value">{{ getSexEnumLabel(metadata.gender) }}</span>
      </div>
    </div>
    <div class="card__rows">
      <div class="card__row" *ngIf="metadata?.maritalStatus">
        <span class="card__label" i18n>État civil</span>
        <span class="card__value">{{
          getCivilStatusLabel(metadata.maritalStatus)
        }}</span>
      </div>
      <div class="card__row" *ngIf="metadata?.nationality">
        <span class="card__label" i18n>Nationalité</span>
        <span class="card__value">{{
          getCountryName(metadata.nationality, 'fr')
        }}</span>
      </div>
      <div class="card__row" *ngIf="metadata?.childrenCount !== undefined">
        <span class="card__label" i18n>Nombre d'enfants</span>
        <span class="card__value">{{ metadata.childrenCount }}</span>
      </div>
      <div class="card__row" *ngIf="metadata?.lppPlan">
        <span class="card__label" i18n>Plan LPP</span>
        <span class="card__value">{{
          getCollaboratorLPPPlanLabel(metadata.lppPlan)
        }}</span>
      </div>
      <div class="card__row" *ngIf="metadata?.residencyPermitKeys?.length > 0">
        <span class="card__label" i18n>Permis de séjour</span>
        <span class="d-flex gap-2 card__value">
          <app-file-icon
            class="clickable"
            *ngFor="let key of metadata?.residencyPermitKeys"
            height="20px"
            width="20px"
            (click)="viewFile(key)"
            (keydown.enter)="viewFile(key)"
            (keydown.space)="viewFile(key)"
            tabindex="0"
            role="button"
          />
        </span>
      </div>
    </div>
  </div>
</app-card>

<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Coordonnées</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row" *ngIf="metadata?.email || originalMetadata?.email">
        <span class="card__label" i18n>Email</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && originalMetadata.email !== metadata.email,
            }"
            >{{ metadata.email }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.email &&
              originalMetadata.email !== metadata.email
            "
            >{{ originalMetadata.email }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.address || originalMetadata?.address"
      >
        <span class="card__label" i18n>Adresse</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.address !== metadata.address,
            }"
            >{{ metadata.address }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.address &&
              originalMetadata.address !== metadata.address
            "
            >{{ originalMetadata.address }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.postCode || originalMetadata?.postCode"
      >
        <span class="card__label" i18n>Code postal</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.postCode !== metadata.postCode,
            }"
            >{{ metadata.postCode }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.postCode &&
              originalMetadata.postCode !== metadata.postCode
            "
            >{{ originalMetadata.postCode }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.city">
        <span class="card__label" i18n>Ville</span>
        <span class="card__value">{{ metadata.city }}</span>
      </div>
    </div>
    <div class="card__rows">
      <div class="card__row" *ngIf="metadata?.mobile">
        <span class="card__label" i18n>Téléphone</span>
        <span class="card__value"
          >{{ metadata.countryCode }} {{ metadata.mobile }}</span
        >
      </div>
      <div class="card__row" *ngIf="metadata?.state">
        <span class="card__label" i18n>Canton</span>
        <span class="card__value">{{ metadata.state }}</span>
      </div>
      <div class="card__row" *ngIf="metadata?.country">
        <span class="card__label" i18n>Pays</span>
        <span class="card__value">{{
          getCountryName(metadata.country, 'fr')
        }}</span>
      </div>
    </div>
  </div>
</app-card>

<app-card class="flex-basis-100 mb-12" *ngIf="displayContractDetails(metadata)">
  <div cardTitle i18n>Détails du contrat</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row" *ngIf="metadata?.contractDetails?.startDate">
        <span class="card__label" i18n>Date de début</span>
        <span class="card__value">{{
          metadata.contractDetails.startDate | date: DATE_FORMAT
        }}</span>
      </div>
      <div class="card__row" *ngIf="metadata?.contractDetails?.function">
        <span class="card__label" i18n>Fonction</span>
        <span class="card__value">{{ metadata.contractDetails.function }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.contractDetails?.occupancyRate !== undefined"
      >
        <span class="card__label" i18n>Taux d'occupation</span>
        <span class="card__value"
          >{{ metadata.contractDetails.occupancyRate }}%</span
        >
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.contractDetails?.annualAvsSalary !== undefined"
      >
        <span class="card__label" i18n>Salaire annuel AVS</span>
        <span class="card__value"
          >{{ metadata.contractDetails.annualAvsSalary }} CHF</span
        >
      </div>
    </div>
    <div class="card__rows">
      <div class="card__row" *ngIf="metadata?.contractDetails?.contractType">
        <span class="card__label" i18n>Type de contrat</span>
        <span class="card__value">{{
          getCollaboratorContractTypeLabel(
            metadata.contractDetails.contractType
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.contractDetails?.multipleEmployers !== null &&
          metadata?.contractDetails?.multipleEmployers !== undefined
        "
      >
        <span class="card__label" i18n>Employeurs multiples</span>
        <span class="card__value">{{
          metadata.contractDetails.multipleEmployers ? 'Oui' : 'Non'
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.contractDetails?.thirteenthMonth !== null &&
          metadata?.contractDetails?.thirteenthMonth !== undefined
        "
      >
        <span class="card__label" i18n>13ème mois</span>
        <span class="card__value">{{
          metadata.contractDetails.thirteenthMonth ? 'Oui' : 'Non'
        }}</span>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="displayPreviousLppDetails(metadata)"
>
  <div cardTitle i18n>Détails de la LPP précédente</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row" *ngIf="metadata?.previousLppDetails?.lastName">
        <span class="card__label" i18n>Nom de la personne de contact</span>
        <span class="card__value">{{
          metadata.previousLppDetails.lastName
        }}</span>
      </div>
      <div class="card__row" *ngIf="metadata?.previousLppDetails?.firstName">
        <span class="card__label" i18n>Prénom de la personne de contact</span>
        <span class="card__value">{{
          metadata.previousLppDetails.firstName
        }}</span>
      </div>
      <div class="card__row" *ngIf="metadata?.previousLppDetails?.email">
        <span class="card__label" i18n>Email de la personne de contact</span>
        <span class="card__value">{{ metadata.previousLppDetails.email }}</span>
      </div>
      <div class="card__row" *ngIf="metadata?.previousLppDetails?.phone">
        <span class="card__label" i18n
          >Téléphone de la personne de contact</span
        >
        <span class="card__value"
          >{{ metadata.countryCode }}
          {{ metadata.previousLppDetails.phone }}</span
        >
      </div>
    </div>
    <div class="card__rows">
      <div class="card__row" *ngIf="metadata?.previousLppDetails?.pensionFund">
        <span class="card__label" i18n>Caisse de pension</span>
        <span class="card__value">{{
          metadata.previousLppDetails.pensionFund
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.previousLppDetails?.referenceNumber"
      >
        <span class="card__label" i18n>Numéro de référence</span>
        <span class="card__value">{{
          metadata.previousLppDetails.referenceNumber
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.previousLppDetails?.estimatedCreditAmount !== undefined
        "
      >
        <span class="card__label" i18n>Montant du crédit estimé</span>
        <span class="card__value"
          >{{ metadata.previousLppDetails.estimatedCreditAmount }} CHF</span
        >
      </div>
    </div>
  </div>
  <app-pdf-viewer-modal #pdfViewer />
</app-card>
